module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/sell-property-videocall-small.dee68fdf9a8a180ba247a68700abd79c.jpg";